import React from "react";

const SciCommitteeCard = ({ name, desig, url }) => {
  return (
    <>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="no-underline"
      >
        <div className="ml-6 sm:ml-0 w-[18rem] sm:w-[28.5rem] lg:w-[15rem] xl:w-[15rem] bg-[#f1f1f5]  h-[6rem] shadow-lg rounded-sm flex flex-col justify-center items-center hover:shadow-2xl transition-shadow duration-200 hover:cursor-pointer mt-12">
          <div className="text-lg font-semibold">{name}</div>
          <div className="text-sm text-center w-[80%]">{desig}</div>
        </div>
      </a>
    </>
  );
};

export default SciCommitteeCard;
